// Utility to get the full URL for images
// Handles both relative URLs (from uploads) and absolute URLs (external)
export const getImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};
